import React from "react";
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';

function SuccessAlert({open, setOpen}) {
    return (
        <div className="success-alert">
            <Collapse in={open}>
                <Alert
                    severity="success"
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit"/>
                        </IconButton>
                    }
                >
                    Muudatused edukalt salvestatud!
                </Alert>
            </Collapse>
        </div>
    );
}

export default SuccessAlert;